export default __webpack_public_path__ + "static/media/high-res-logo-p-800.2bbd4bf2.webp";